/*
 * @Autor: Nehc
 * @Date: 2020-12-11 10:54:34
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-11 11:16:51
 */
import LogRule from './table.vue';

export default LogRule;
